const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/cases',
  component: Module,
  children: [
    {
      path: '/',
      name: 'cases-home',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
